import React from 'react';

import { type IWithChildren } from '../../types/interfaces';

import styles from './custom-header.module.css';

export const CustomHeader = ({ children }: IWithChildren) => <span className={styles.customHeader}>{children}</span>;
